import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import TitleInput from "../../components/molecules/input/titleInput";
import MainBtn from "../../components/atoms/button/mainBtn";
import AuthApi from "../../api/auth.api";
import { errorHandler } from "../../util/errorHandler";

const IDFindComplete = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();
  const { phone, smsVerificationToken } = location.state || {};

  const navigate = useNavigate();

  const [idValue, setIdValue] = useState("");

  useEffect(() => {
    if (phone && smsVerificationToken) {
      idInfoFunc();
    } else {
      navigate(route.id_find, { replace: true });
    }
  }, [phone, smsVerificationToken]);

  const idInfoFunc = async () => {
    try {
      const data = {
        phoneNumber: phone,
        smsVerificationToken,
      };
      const response = await AuthApi.idFind(data);

      setIdValue(response.data.data);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <IDFindCompleteSection>
        <PCContainer
          style={{
            padding: isSmall ? "80px 20px 80px 20px" : "80px 0px 150px 0px",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: isMobile ? "100%" : 790,
              padding: isMobile
                ? "0px"
                : isTablet
                ? "60px 140px"
                : "60px 205px",
              boxShadow: isMobile ? "none" : "0px 0px 6px 0px #0000001A",
              borderRadius: isMobile ? 0 : 30,
            }}
          >
            <LSBdDisplay02
              style={{
                textAlign: "center",
                marginBottom: 4,
              }}
            >
              아이디 찾기
            </LSBdDisplay02>
            <LSRgH1HeadLine
              style={{
                textAlign: "center",
                marginBottom: 32,
                color: "#898E99",
              }}
            >
              회원님의 아이디는 아래와 같습니다.
            </LSRgH1HeadLine>

            <TitleInput
              title={"아이디"}
              essential={false}
              placeholder={""}
              type={"text"}
              value={
                idValue?.joinType === "NORMAL"
                  ? idValue?.account
                  : `${idValue?.joinType}로 가입된 회원입니다.`
              }
              style={{
                marginBottom: isMobile ? 24 : 20,
              }}
            />

            <MainBtn
              onClick={() => {
                navigate(route.login);
              }}
              style={{
                marginTop: 8,
              }}
            >
              <LSRgH1HeadLine
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                로그인 하기
              </LSRgH1HeadLine>
            </MainBtn>
          </div>
        </PCContainer>
      </IDFindCompleteSection>
    </>
  );
};

export default IDFindComplete;

const IDFindCompleteSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
